import React, { useState } from "react";
import Navbar from "../layout/Navbar";

import hero from "../assets/images/accomodation.png";

import SearchWithDate from "../components/elements/SearchWithDate";
import AccommodationCard from "../components/cards/mobileView/AccommodationCard";
import Icon from "../components/Icon";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

import BlogCard from "../components/cards/BlogCard";
import useWidth from "../hooks/useWidth";
import AccommodationMobile from "./mobile/AccommodationMobile";

import { getAllCities, getHotelByCity, recentBlogs } from "../apis";
import { useFetch } from "../hooks/useFetch";
import PropertyCard from "../components/cards/PropertyCard";
import { Link } from "react-router-dom";
import Loader from "../components/elements/Loader";

const Accommodation = () => {
  const width = useWidth();
  const [filters, setFilters] = useState({ cityName: "Mathura", amenities: [] })  

  const [hotelDetails, setHotelDetails,loading] = useFetch(getHotelByCity, {}, filters)
  const [locations] = useFetch(getAllCities, [])
  const [blogs] = useFetch(recentBlogs, [])


  return (
    <>
      <Loader loading={loading} />
      {width < 992 ? (
        <AccommodationMobile hotelDetails={hotelDetails} locations={locations} mainFilter={filters} setMainFilter={setFilters} />
      ) : (
        <>
          <Navbar />
          {/* hero Section */}
          <section>
            <div className="hero-section " style={{ padding: "8rem"}}>
              <img src={hero} className="w-100 h-100 hero-img" alt="" />
              <div
                className=" hero-inner d-flex justify-content-center  flex-column"
                style={{ position: "relative" }}
              >
                <div
                  className="w-100 h-100 d-flex align-item-end flex-column"
                >
                  <h1 className="accomodation">
                    Recent reviews. Affordable prices
                  </h1>
                  <div className="d-flex w-100 justify-content-center">
                    <div className="d-flex  w-100 flex-column mt-4">
                      <div className="w-100 d-flex justify-content-center">
                        <SearchWithDate
                          placeholder={"Search for City or Hotel"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>


          {/* accommodation */}
          <section>
            <div className="px-4 pt-5 mb-3">
              <div className="d-flex justify-content-between">
                <div className="top-heading">Home Accommodations Near You</div>
                <div className="d-flex gap-4">
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      background: "#3a86ff",
                    }}
                  >
                    <Icon className="text-light" icon={faArrowLeft} />
                  </div>
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      background: "#e95a1a",
                    }}
                  >
                    <Icon className="text-light" icon={faArrowRight} />
                  </div>
                </div>
              </div>
            </div>
            <ul className="list-unstyled d-flex scrollbar-hidden">
              {locations?.map((location, i) => (
                  <li className="m-2">
                    <AccommodationCard data={location}/>
                  </li>
                ))}
            </ul>
          </section>


            <section>
              <div className="d-flex top-heading-container p-4">
                <div className="top-heading heading-center ">Quick Picks for you</div>
                <Link to={'/search-result'} className="view-all" style={{ width: "auto" }}>
                  View More
                </Link>
              </div>

              <ul
                className="list-unstyled d-flex overflow-auto"
                style={{ scrollbarWidth: "none" }}
              >
                {hotelDetails?.hotels?.map((hotel, i) => (
                  <li className="p-3">
                    <div className="property-card-container">
                      <PropertyCard data={hotel} />
                    </div>
                  </li>
                ))}
              </ul>
            </section>

          {/* blogs */}
          <section>
            <div className="row mx-0 px-4 pt-5">
              <div className="col-md-8 p-0">
                <div className="top-heading">Latest Blog &amp; News</div>
                <div className="top-destinations-subHeading mt-2">
                  Making the Most of Your Travel Experience in 2024
                </div>
              </div>
              <div className="col-md-4 d-flex justify-content-end">
                <Link to={'/blogs'} className="view-all w-50">Know More</Link>
              </div>
              </div>
              <div className="mt-4 px-4">
                <div className="d-flex overflow-auto scrollbar-hidden p-0 ">
                  {blogs.map((blog, i) => (
                    <div key={i} className="col-sm-12 col-md-6 col-lg-3 ">
                      <div className="m-2">
                        <BlogCard data={blog} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
          </section>
        </>
      )}
    </>
  );
};

export default Accommodation;
